var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3v12h17V3zm16 11H1V4h15zm-13.438-.489-1-.022c.033-1.43 1.398-2.652 3.309-3.017v-.326c-.248-.259-.425-.61-.545-.923a1.24 1.24 0 0 1-.399-.516c-.185-.41-.153-.821.063-1.068a4 4 0 0 1-.006-.217l-.002-.184c-.006-.537-.016-1.42.929-1.584.194-.339.483-.627 1.179-.651 1.123-.035 1.916.378 2.185 1.151.091.265.006.485-.056.645-.059.152-.115.295-.082.564.013.107.011.212.003.312.175.237.211.597.082.975-.095.273-.249.484-.434.608-.111.287-.27.604-.487.845v.377c1.909.375 3.228 1.571 3.261 3.008l-1 .023c-.023-1.021-1.21-1.908-2.823-2.109l-.438-.055V9.638l.2-.15c.106-.08.271-.321.415-.761l.135-.344.074-.631c.014-.106.027-.207.019-.268-.062-.52.066-.85.142-1.046l.012-.031c-.21-.396-.879-.413-1.171-.406-.277.011-.297.05-.351.153-.068.132-.229.442-.637.478-.092.008-.121.027-.121.027-.041.064-.038.367-.036.568l.001.195q0 .213.029.446l.07.573.12.021.003.248c.154.466.339.721.451.798l.215.149v1.687l-.442.052c-1.612.189-2.844 1.098-2.867 2.115M15 8h-5V7h5zm-1 2h-4V9h4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card.svg";